import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Technical task - Quiz")
const _hoisted_3 = { class: "form__fields-wrapper" }
const _hoisted_4 = { class: "form__field-wrapper" }
const _hoisted_5 = { class: "form__input-feedback" }
const _hoisted_6 = {
  key: 0,
  class: "form__error-message"
}
const _hoisted_7 = {
  key: 1,
  class: "form__field-wrapper"
}
const _hoisted_8 = { class: "form__input-feedback" }
const _hoisted_9 = {
  key: 0,
  class: "form__error-message"
}
const _hoisted_10 = { class: "form__submit-wrapper" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Start")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading1 = _resolveComponent("Heading1")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FetchingError = _resolveComponent("FetchingError")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Heading1, { class: "quiz-form-heading" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("form", {
      class: "form",
      novalidate: "",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TextInput, {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formValues.name = $event)),
            id: 'name',
            "model-value": _ctx.formValues.name,
            "validation-error": 
              _ctx.v$.$dirty && (_ctx.v$.formValues.name.$error ? 'invalid' : 'valid')
            ,
            placeholder: 'Please enter your name',
            label: 'Name',
            focused: true
          }, null, 8, ["model-value", "validation-error"]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.v$.formValues.name.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.v$.formValues.name.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.fetchingError)
          ? (_openBlock(), _createBlock(_component_FetchingError, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_Select, {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formValues.quizId = $event)),
                id: 'test',
                "model-value": _ctx.formValues.quizId,
                "select-options": _ctx.selectOptions,
                "validation-error": 
              _ctx.v$.$dirty && (_ctx.v$.formValues.quizId.$error ? 'invalid' : 'valid')
            ,
                placeholder: 'Please choose test',
                label: 'Test'
              }, null, 8, ["model-value", "select-options", "validation-error"]),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.v$.formValues.quizId.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.v$.formValues.quizId.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Button, { variant: "primary" }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ], 32)
  ]))
}